import { Grid } from '@material-ui/core'
import { graphql } from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import useSiteSettings from '../../../hooks/useSiteSettings'
import CreditCardLogo from '../../CreditCardLogo'
import { StyledFunctionComponent } from '../../types'

const StyledTitle = styled.h4`
  color: ${({ theme }) => theme.colors.coolGray.cool600};
  font-weight: 400;
  line-height: 28px;
  margin: 0;
`

const StyledLogos = styled.div`
  font-size: 22px;
  line-height: 28px;
`

const StyledCreditCardLogo = styled(CreditCardLogo)`
  margin-left: 8px;
`

const AcceptedCreditCards: StyledFunctionComponent = ({ className }) => {
  const { acceptedCreditCards } = useSiteSettings() || {}
  return (
    <Grid className={className} item sm={12} xs={12}>
      <StyledTitle>Add a Card</StyledTitle>
      <StyledLogos>
        {acceptedCreditCards?.visa && <StyledCreditCardLogo ccType="VI" />}
        {acceptedCreditCards?.discover && <StyledCreditCardLogo ccType="DC" />}
        {acceptedCreditCards?.mastercard && <StyledCreditCardLogo ccType="MC" />}
        {acceptedCreditCards?.amex && <StyledCreditCardLogo ccType="AE" />}
      </StyledLogos>
    </Grid>
  )
}

const StyledAcceptedCreditCards = styled(AcceptedCreditCards)({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
})

export default StyledAcceptedCreditCards

export const acceptedCreditCards = graphql`
  fragment acceptedCreditCards on SanitySiteSettings {
    acceptedCreditCards {
      amex
      discover
      mastercard
      visa
    }
  }
`
